module.exports = __webpack_public_path__ + "img/advertise_intruduct2.c51ca502.png";